class XHR {
    constructor(options) {
        this.url = options.url;
        this.body = this.formatdata(options.data);
        this.contentType = typeof options.contentType !== 'undefined' ? options.contentType : 'application/x-www-form-urlencoded';
    }

    formatdata(data) {
        var array = [];
        Object.keys(data).forEach(element =>
            array.push(
                encodeURIComponent(element) + '=' + encodeURIComponent(data[element])
            )
        );
        var body = array.join('&');
        return body;
    }

    send(successCallback, errorCallback, callbackId) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', this.url);
        xhr.setRequestHeader('Content-type', this.contentType);
        xhr.send(this.body);

        xhr.onreadystatechange = () => {
            var DONE = 4; // readyState 4 means the request is done.
            var OK = 200; // status 200 is a successful return.
            if (xhr.readyState === DONE) {
                if (xhr.status === OK) {
                    // 'This is the returned text.'
                    successCallback(xhr.responseText, callbackId);
                } else {
                    console.log('Error: ' + xhr.status); // An error occurred during the request.
                    errorCallback(xhr.status, callbackId);
                }
            }
        };
    }
}

export default XHR;



// WEBPACK FOOTER //
// ./scripts/lib/xhr.js